import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon, TimerIcon } from 'lucide-react';
export function UrgencyBanner() {
  // Set initial time to 3 hours, 45 minutes, 20 seconds
  const [timeLeft, setTimeLeft] = useState(3 * 3600 + 45 * 60 + 20);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <motion.section initial={{
    opacity: 0,
    scale: 0.95
  }} whileInView={{
    opacity: 1,
    scale: 1
  }} viewport={{
    once: true
  }} className="py-8" data-id="element-185">
      <div className="bg-brand-card border-2 border-brand-orange/30 rounded-2xl p-6 md:p-8 text-center relative overflow-hidden shadow-glow" data-id="element-186">
        <div className="absolute top-0 left-0 w-full h-1 bg-white/10" data-id="element-187">
          <motion.div initial={{
          width: 0
        }} animate={{
          width: '85%'
        }} transition={{
          duration: 1.5,
          ease: 'easeOut'
        }} className="h-full bg-brand-orange shadow-glow" data-id="element-188" />
        </div>

        <div className="flex items-center justify-center gap-2 text-brand-orange mb-4" data-id="element-189">
          <AlertCircleIcon className="w-5 h-5" data-id="element-190" />
          <p className="font-bold text-sm md:text-base uppercase tracking-wider" data-id="element-191">
            Inventory Alert: 85% Sold Out
          </p>
        </div>

        <div className="flex items-center justify-center gap-4 mb-6" data-id="element-192">
          <TimerIcon className="w-8 h-8 text-white/50" data-id="element-193" />
          <div className="flex gap-3 text-3xl md:text-4xl font-mono font-bold text-white" data-id="element-194">
            <div className="flex flex-col items-center" data-id="element-195">
              <span data-id="element-196">{hours.toString().padStart(2, '0')}</span>
              <span className="text-xs text-brand-muted font-sans mt-1" data-id="element-197">
                HRS
              </span>
            </div>
            <span className="text-brand-orange" data-id="element-198">:</span>
            <div className="flex flex-col items-center" data-id="element-199">
              <span data-id="element-200">{minutes.toString().padStart(2, '0')}</span>
              <span className="text-xs text-brand-muted font-sans mt-1" data-id="element-201">
                MIN
              </span>
            </div>
            <span className="text-brand-orange" data-id="element-202">:</span>
            <div className="flex flex-col items-center" data-id="element-203">
              <span data-id="element-204">{seconds.toString().padStart(2, '0')}</span>
              <span className="text-xs text-brand-muted font-sans mt-1" data-id="element-205">
                SEC
              </span>
            </div>
          </div>
        </div>

        <p className="text-brand-muted text-sm mb-6" data-id="element-206">
          Sale ends when the countdown hits zero or stock runs out.
        </p>

        <motion.button whileHover={{
        scale: 1.03
      }} whileTap={{
        scale: 0.97
      }} onClick={() => document.getElementById('bundles')?.scrollIntoView({
        behavior: 'smooth'
      })} className="w-full sm:w-auto px-8 py-4 bg-brand-orange text-white text-lg font-bold rounded-xl shadow-glow hover:shadow-glow-hover transition-all duration-300" data-id="element-207">
          CLAIM MY LUMIMATE - 40% OFF TODAY
        </motion.button>
      </div>
    </motion.section>;
}